import { getCurrentInstance, Ref, unref } from 'vue';

export interface MaxLengthProps {
    maxLength?: number
}

/**
 * @deprecated
 */
export const maxLengthProps = {
    maxLength: {
        type: Number,
        default: null,
    },
};

export function useMaxLengthComposable() {
    const { props } = getCurrentInstance() as { props: MaxLengthProps };
    function validateMaxLength(value: string|null|Ref<string|null>, validationMessageRef: Ref<string|null>|null = null) {
        if (!value) {
            return true;
        }
        if (!props.maxLength) {
            return true;
        }
        if (String(unref(value)).length <= props.maxLength) {
            return true;
        }

        const message = 'Dies darf maximal ' + props.maxLength + ' Zeichen enthalten';
        if (validationMessageRef !== null) {
            validationMessageRef.value = message;
        }
        return message;
    }

    return {
        validateMaxLength,
    };
}
